module.exports = __webpack_public_path__ + "img/cima_logo.20b91ad5.svg";